/**
 * Event bindings and handlers for FilterController
 */

export function setupEventListeners(ctx) {
	$(ctx.filterElements.clearButton).on('click', (e) => { ctx.clearAllFilters(); });
	$(ctx.filterElements.filterButton).click(() => { $(ctx.filterElements.counter).toggleClass('bg-warning'); });
	$(ctx.filterElements.dateInputs).on('input', (e) => { ctx.handleDateInputChange(e); });
	
	// Listen to dateRangeChanged event from LiteDateRangePicker
	window.addEventListener('dateRangeChanged', (event) => {
		const { from, to, source } = event.detail || {};
		ctx.activeFilters.dateFrom = from || '';
		ctx.activeFilters.dateTo = to || '';
		
		// Skip URL update if restoring state from browser history
		const isRestoring = window.__isRestoringBrowserState === true;
		if (isRestoring || source === 'restore') {
			return;
		}
		
		// Apply filters immediately (without URL update)
		if (!ctx.isInitializing && window.filterManager && typeof window.filterManager.applyFilters === 'function') {
			window.filterManager.applyFilters(false); // false = don't update URL immediately
		}
		
		// Trigger debounced search to update URL when search executes
		if (!ctx.isInitializing && window.filterManager && typeof window.filterManager.triggerDebouncedSearch === 'function') {
			window.filterManager.triggerDebouncedSearch();
		}
	});
	
	// Event listeners setup logging only in debug mode
}

export function handleFilterChange(ctx, key, selection) {
	try {
	ctx.activeFilters.categories[key] = selection;
		// Only apply filters if not initializing (files may not be loaded yet)
		// Apply filters immediately (without URL update)
		if (!ctx.isInitializing && window.filterManager && typeof window.filterManager.applyFilters === 'function') { 
			window.filterManager.applyFilters(false); // false = don't update URL immediately
		}
		// Trigger debounced search to update URL when search executes
		if (!ctx.isInitializing && window.filterManager && typeof window.filterManager.triggerDebouncedSearch === 'function') {
			window.filterManager.triggerDebouncedSearch();
		}
		try {
			if (typeof window.resetAccountAutocompletion === 'function' && window.jQuery) { window.resetAccountAutocompletion(window.jQuery('#fnd_searchbox')); }
		} catch (_) {}
		// Counter update logging only in debug mode
		ctx.updateFilterCounter();
        // Recompute availability in all groups based on selection
        try { if (typeof ctx.refreshAvailability === 'function') ctx.refreshAvailability(); } catch(_) {}
		ctx.triggerFilterCallbacks();
		
		// Check if fulltext tab is active and update mismatch indicator
		try {
			const fulltextTab = $('#nav-full-text-card-tab');
			if (fulltextTab.length && fulltextTab.hasClass('active')) {
				const searchInput = $('#fnd_searchbox, input[name="sq"], input[name="search"]').first();
				const query = (searchInput.length ? searchInput.val() : window.QUERY || '').toString().trim();
				if (window.updateFulltextRequestMismatchIndicator && typeof window.updateFulltextRequestMismatchIndicator === 'function') {
					window.updateFulltextRequestMismatchIndicator(query);
				}
				// Force highlight name search count when category filters change on fulltext tab
				if (window.FileList && typeof window.FileList.forceHighlightNameSearchCount === 'function') {
					window.FileList.forceHighlightNameSearchCount();
				}
			}
		} catch(_) {}
	} catch (error) {
		if (debugMode === '1') { console.error('[FilterController] Error handling filter change:', error); }
	}
}

export function handleDateInputChange(ctx, event) {
	const isFrom = $(event.target).hasClass('filter-date-from');
	const value = $(event.target).val();
	if (isFrom) { ctx.activeFilters.dateFrom = value; } else { ctx.activeFilters.dateTo = value; }
	clearTimeout(ctx.dateTimeout);
	ctx.dateTimeout = setTimeout(() => { 
		ctx.triggerFilterCallbacks(); 
		// URL will be updated when search is executed (in filterManager.applyFilters)
		// Don't update URL here - wait for actual search execution
		
		// Check if fulltext tab is active and update mismatch indicator
		try {
			const fulltextTab = $('#nav-full-text-card-tab');
			if (fulltextTab.length && fulltextTab.hasClass('active')) {
				const searchInput = $('#fnd_searchbox, input[name="sq"], input[name="search"]').first();
				const query = (searchInput.length ? searchInput.val() : window.QUERY || '').toString().trim();
				if (window.updateFulltextRequestMismatchIndicator && typeof window.updateFulltextRequestMismatchIndicator === 'function') {
					window.updateFulltextRequestMismatchIndicator(query);
				}
				// Force highlight name search count when date filters change on fulltext tab
				if (window.FileList && typeof window.FileList.forceHighlightNameSearchCount === 'function') {
					window.FileList.forceHighlightNameSearchCount();
				}
			}
		} catch(_) {}
	}, 1000);
	if (window.HyperLog) { window.HyperLog.debug('[FilterController] Date filter changed', { isFrom: isFrom, value: value, dateFrom: ctx.activeFilters.dateFrom, dateTo: ctx.activeFilters.dateTo }); }
}


